import { useEffect, useState } from 'react'
import Lottie from 'lottie-react'

import LoaderAdm from '../../../../../assets/svgIcons/LoaderAdm.json'

import ConversationRow from './ConversationRow'
import SearchBar from './SearchBar'

const Conversations = ({
  conversations,
  title,
  handleSelectConversation,
  setConversations,
  loading
}) => {
  const [filteredConversations, setFilteredConversations] = useState(conversations)

  useEffect(() => {
    setFilteredConversations(conversations)
  }, [conversations])

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-3xl border border-primary/10 bg-gradient-to-br from-white via-surface to-primary/[0.03] shadow-[0_24px_70px_rgba(15,23,42,0.08)]">
      <div className="border-b border-primary/10 bg-gradient-to-r from-primary/[0.04] via-white to-accent2/[0.05] px-4 py-4 sm:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className='min-w-0'>
            <h1 className="text-xl font-semibold text-text sm:text-2xl">{title}</h1>
            <p className='mt-1 text-sm text-muted'>
              Retoma conversaciones anteriores, edítalas o márcalas como destacadas.
            </p>
          </div>
          <div className="w-full sm:ml-auto sm:w-auto">
          <SearchBar
            setFilteredConversations={setFilteredConversations}
            conversations={conversations}
          />
          </div>
        </div>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto bg-gradient-to-b from-primary/[0.03] via-white to-border/10 px-3 py-3 sm:px-4 sm:py-4">
        {loading ? (
          <div className='flex items-center justify-center h-64'>
            <Lottie animationData={LoaderAdm} loop style={{ width: 200, height: 200 }} />
          </div>
        ) : (
          filteredConversations.length > 0 ? (
            <div className='flex flex-col gap-3'>
              {filteredConversations.map((conversation) => (
                <ConversationRow
                  key={conversation.id || conversation.name}
                  conversation={conversation}
                  handleSelectConversation={handleSelectConversation}
                  setConversations={setConversations}
                />
              ))}
            </div>
          ) : (
            <div className='flex h-48 flex-col items-center justify-center rounded-3xl border border-dashed border-primary/15 bg-white/80 px-6 text-center shadow-[0_14px_28px_rgba(15,23,42,0.05)]'>
              <div className='text-base font-semibold text-text'>No encontramos chats</div>
              <div className='mt-1 text-sm text-muted'>Prueba con otro nombre o una fecha distinta.</div>
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default Conversations
